module.exports = __webpack_public_path__ + "static/img/rongzicelue.54c1eaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/7mouth/rongzicelue.png
// module id = 3hr6
// module chunks = 1